<template>
    <li v-if="services.includes(presentationMode)" v-bind:data-type="types" v-bind:data-use="uses">
        <a v-bind:href="url">
            <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                <img v-if="presentationMode == 'architecture'" class="featured-image" v-bind:src="archFeaturedImage" width="600" height="400" v-bind:alt="archFeaturedAlt" />
                <img v-else class="featured-image" v-bind:src="designFeaturedImage" width="600" height="400" v-bind:alt="designFeaturedAlt" />
                
                <div class="uk-transition-fade uk-position-cover uk-overlay uk-overlay-default uk-position-top">
                    <h4 class="uk-margin-remove uk-text-bold">{{ title }}</h4>
                    <p v-if="subtitle" class="uk-margin-remove uk-text-bold">{{ subtitle }}</p>
                </div>
            </div>
        </a>
    </li>
</template>
<script>
export default {
    props: ['presentationMode', 'id', 'title', 'subtitle', 'url', 'archFeaturedImage', 'archFeaturedAlt', 'designFeaturedImage', 'designFeaturedAlt', 'types', 'uses', 'services']
}
</script>




// WEBPACK FOOTER //
// src/components/ProjectItem.vue